<template>
  <div class="main-feed mt-5">
    <div>
      <v-row class="ma-0">
        <h2>{{title}}</h2>
        <v-spacer></v-spacer>
        <RequestStatusesSelectMenu
          :menu.sync="menu"
          v-on:apply="applyFilters"
          v-on:updateStatuses="statuses = $event"
        />
      </v-row>
    </div>
    <v-data-table 
      :loading="loading"
      :headers="headers"
      :options.sync="options"
      :items="paginatedResponse.data"
      :server-items-length="paginatedResponse.totalCount"
      :search="search"
      :footer-props="footerProps">
        <template v-slot:item.requestId="{ item }">
          <router-link :to="`/admin/changekennelowners/${item.requestId}`" target="_blank">{{
            item.requestId
          }}</router-link>
        </template>
        <template v-slot:item.submittedAt="{ item }">
          <localized-date-time :instant="item.submittedAt" />
        </template>
        <template v-slot:item.requester="{ item }">
          <span>{{ item.requester.lastName }}, {{ item.requester.firstName }}</span>
        </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import RequestStatusesSelectMenu from "@/components/common/inputs/RequestStatusesSelectMenu.vue";

import { MetaNames } from "@/constants";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import workflowService from '@/services/admin/workflowService';

export default Vue.extend({
  name: "ChangeKennelOwnerRequestList",
  components: { RequestStatusesSelectMenu },
  props: {
    readyToApproveOnly: String,
  },
  data: function () {
    return {
      loading: false,
      title: MetaNames.AdminKennelChangeOwners,
      paginatedResponse: {} as PaginatedResponse<object>,
      menu: false,
      search: '',
      statuses: ["RequestFinalized"],
      options: {} as PaginationOptions,
      headers: [
        { text: "#ID", align: "left", value: "requestId" },
        { text: "Submitted at", align: "left", value: "submittedAt" },
        { text: "Requester", align: "left", value: "requester", sortable: false },
        { text: "Status", align: "left", value: "status" },
        { text: "Kennel Id", align: "left", value: "kennelId" },
        { text: "Kennel Name", align: "left", value: "kennelName" },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
    };
  },
  created: function () { this.loadList() },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    }
  },
  methods: {
    applyFilters: function () {
      this.menu = false;
      this.loadList();
    },
    loadList: async function () {
      this.loading = true;
      const {
        page,
        itemsPerPage,
      } = this.options;

      const response = await workflowService.getKennelChangeOwnerRequestsList({
        ...this.options,
        page: (page ?? 1) - 1,
        itemsPerPage: itemsPerPage ?? 10
      }, this.$data.statuses);

      this.loading = false;
      this.paginatedResponse = response;
    },
  },
});
</script>
